module.exports = __webpack_public_path__ + "static/integrations-ae862f65f7dd07f809774f8b5d8bd12f.png";